<template>
  <div>

    <cc-collapse :title="$t('ct-general-settings')">
      <div class="form-group">
        <label for="box-hover-theme">{{ $t('ct-box-hover-config') }}</label>
        <select id="box-hover-theme" name="box-hover-theme" class="form-control" v-model="config.effect"
                @change="setBoxHoverConfig('effect', config.effect)">
          <option value="1">{{ $t('ct-box-hover-effect-1') }}</option>  <!--  ihover 3 -->
          <option value="2">{{ $t('ct-box-hover-effect-2') }}</option>  <!--  ihover 4 -->
          <option value="3">{{ $t('ct-box-hover-effect-3') }}</option>  <!--  ihover 6 -->
          <option value="4">{{ $t('ct-box-hover-effect-4') }}</option>  <!--  ihover 7 -->
          <option value="5">{{ $t('ct-box-hover-effect-5') }}</option>  <!--  ihover 9 -->
          <option value="6">{{ $t('ct-box-hover-effect-6') }}</option> <!--  ihover 11 -->
          <option value="7">{{ $t('ct-box-hover-effect-7') }}</option> <!--  ihover 14 -->
          <option value="8">{{ $t('ct-box-hover-effect-8') }}</option>  <!--  ihover 16 -->
          <option value="9">{{ $t('ct-box-hover-effect-9') }}</option>  <!--  ihover 18 -->
          <option value="10">{{ $t('ct-box-hover-effect-10') }}</option>  <!--  ihover 19 -->
        </select>
      </div>

      <div class="form-group">
        <label for="box-hover-direction">{{ $t('ct-box-hover-direction') }}</label>

        <select id="box-hover-direction" name="box-hover-direction" class="form-control" v-model="config.direction"
                @change="setBoxHoverConfig('direction', config.direction)">

          <template v-if="config.effect === '3'">
            <option value="scale_up">{{ $t('ct-box-hover-scale-up') }}</option>
            <option value="scale_down">{{ $t('ct-box-hover-scale-down') }}</option>
            <option value="scale_down_up">{{ $t('ct-box-hover-scale-down-up') }}</option>
          </template>

          <template v-else>
            <option value="left_to_right">{{ $t('ct-box-hover-left-to-right') }}</option>
            <option value="right_to_left">{{ $t('ct-box-hover-right-to-left') }}</option>

            <template v-if="!['8'].includes(config.effect)">
              <option value="bottom_to_top">{{ $t('ct-box-hover-bottom-to-top') }}</option>
              <option value="top_to_bottom">{{ $t('ct-box-hover-top-to-bottom') }}</option>
            </template>
          </template>
        </select>
      </div>
    </cc-collapse>

    <cc-collapse :title="$t('ct-box-hover-img')">
      <cc-box-color ref="backgroundCoverColor"></cc-box-color>
      <cc-image-component ref="backgroundCoverImage" nameConfig="backgroundCoverImage" :activeAttachment="false"></cc-image-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-background-settings')">
      <cc-box-color ref="backgroundHoverColor"></cc-box-color>
      <cc-image-component ref="backgroundHoverImage" nameConfig="backgroundCoverImage" :activeAttachment="false"></cc-image-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-sizes')">
      <cc-slider-component ref="widthConfig"></cc-slider-component>
      <cc-slider-component ref="heightConfig"></cc-slider-component>
      <cc-slider-component ref="minHeightConfig"></cc-slider-component>
      <cc-slider-component ref="minWidthTabletConfig"></cc-slider-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-border')">
      <cc-border-component ref="border"></cc-border-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-border-radius')">
      <cc-border-radius-component ref="borderRadius"></cc-border-radius-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-shadow')">
      <cc-shadow ref="shadow"></cc-shadow>
    </cc-collapse>

    <cc-collapse :title="$t('ct-padding')" class="padding-mobile">
      <cc-padding ref="padding"></cc-padding>
    </cc-collapse>

    <cc-collapse :title="$t('ct-tag')">
      <cc-tag ref="tag"></cc-tag>
    </cc-collapse>

    <cc-collapse :title="$t('ct-layers')">
      <cc-z-index ref="z-index"></cc-z-index>
    </cc-collapse>

  </div>

</template>

<script>

import MixinComponentsOptions from "../../../../js/mixins/MixinComponentsOptions";


export default {
  name: 'BoxHoverOptions',
  mixins: [MixinComponentsOptions],
  data() {
    return {
      config: {},
      callback: () => {}
    };
  },
  methods: {
    init(config, callback) {
      let vm = this;

      vm.config = _.clone(config);

      vm.callback = callback;

      // sizes
      this.$refs['widthConfig'].setValues({
        defaultValue: vm.config.width,
        defaultValueChecked: true,
        min: 50,
        max: 1400,
        canBeCheckbox: false,
        labelDesc: 'width',
        name: 'iconColor',
        callback: vm.setWidth
      });

      this.$refs['heightConfig'].setValues({
        defaultValue: vm.config.height,
        defaultValueChecked: true,
        min: 10,
        max: 800,
        canBeCheckbox: false,
        labelDesc: 'height',
        name: 'iconColor',
        callback: vm.setHeight
      });

      this.$refs['minHeightConfig'].setValues({
        defaultValue: vm.config.minHeight,
        defaultValueChecked: true,
        min: 10,
        max: 800,
        canBeCheckbox: false,
        labelDesc: 'min-height',
        name: 'iconColor',
        callback: vm.setMinHeight
      });

      this.$refs['minWidthTabletConfig'].setValues({
        defaultValue: vm.config.maxWidth,
        defaultValueChecked: true,
        min: 50,
        max: 800,
        canBeCheckbox: false,
        labelDesc: 'max-width-tablet',
        name: 'iconColor',
        callback: vm.setMaxWidth
      });

      // border
      this.$refs['border'].setValues({
        defaultValue: vm.config.border,
        labelDesc: 'border',
        name: 'border',
        callback: vm.setBorder
      });

      // borderRadius
      this.$refs['borderRadius'].setValues({
        defaultValue: vm.config.borderRadius,
        labelDesc: 'borderRadius',
        name: 'borderRadius',
        callback: vm.setBorderRadius
      });

      // shadow
      this.$refs['shadow'].setValues({
        defaultValue: vm.config.boxShadow,
        labelDesc: 'shadow',
        name: 'shadow',
        callback: vm.setShadow
      });

      // padding
      this.$refs['padding'].setValues({
        defaultTop: vm.config.paddingTop,
        defaultBottom: vm.config.paddingBottom,
        defaultLeft: vm.config.paddingLeft,
        defaultRight: vm.config.paddingRight,
        min: 0,
        max: 150,
        labelDesc: 'padding',
        callback: vm.setPadding
      });

      // tag
      this.$refs['tag'].setValues({tag: vm.config.tag, callback: vm.setTag});

      // z-index
      this.$refs['z-index'].setValues({defaultValue: vm.config.zIndex, callback: vm.setZIndex});

      // background
      this.$refs['backgroundCoverImage'].setValues({
        ...vm.getValuesBackground('cover'),
        callback: vm.setBackgroundCoverImage
      });

      this.$refs['backgroundCoverColor'].setValues({
        defaultValue: vm.config['cover'].backgroundColor,
        gradient: true,
        labelDesc: 'bg-color',
        name: 'backgroundColor',
        callback: vm.setBackgroundCoverColor
      });

      this.$refs['backgroundHoverColor'].setValues({
        defaultValue: vm.config['hover'].backgroundColor,
        gradient: true,
        labelDesc: 'bg-color',
        name: 'backgroundColor',
        callback: vm.setBackgroundHoverColor
      });

      this.$refs['backgroundHoverImage'].setValues({
        ...vm.getValuesBackground('hover'),
        callback: vm.setBackgroundHoverImage
      });

    },
    getValuesBackground(type) {
      return {
        id: type,
        defaultValue: this.config[type].backgroundImage,
        defaultValueOrigin: this.config[type].backgroundOrigin,
        defaultValueRepeat: this.config[type].backgroundRepeat,
        defaultValueSize: this.config[type].backgroundSize,
        defaultValueAttachment: '',
        defaultValuePosition: this.config[type].backgroundPosition,
        canExternal: true,
        canRemove: true,
      }
    },
    setHeight(value) {
      this.config.height = `${value}px`;
      this.save();
    },
    setMinHeight(value) {
      this.config.minHeight = `${value}px`;
      this.save();
    },
    setBackgroundHoverColor(value) {
      this.config['hover'].backgroundColor = value;
      this.save();
    },
    setBackgroundCoverColor(value) {
      this.config['cover'].backgroundColor = value;
      this.save();
    },
    setBoxHoverConfig(config, value) {
      if (typeof value === 'undefined') {
        return;
      }

      this.config[config] = value;

      if (config === 'effect') {
        // Trocar direções de efeito diferente do padrão
        if (this.config['effect'] === '3' && !['scale_up', 'scale_down', 'scale_down_up'].includes(this.config.direction)) {
          this.config['direction'] = 'scale_up';
        } else if (this.config['effect'] === '8' && ['bottom_to_top', 'top_to_bottom'].includes(this.config.direction)) {
          this.config['direction'] = 'left_to_right';
        }

        // Se for diferente do padrão mas com efeito padrão seta a primeira direção
        else if (['scale_up', 'scale_down', 'scale_down_up'].includes(this.config.direction)) {
          this.config['direction'] = 'left_to_right';
        }
      }

      this.save();
    },
    setImage(data) {
      if (data.type === 'setImage') {
        this.config.src = data.src;
      }

      if (data.type === 'removeImage') {
        this.config.src = '';
      }
      this.save();
    },
    setBackgroundCoverImage(data) {
      this.setBackgroundImage(data, 'cover');
    },
    setBackgroundHoverImage(data) {
      this.setBackgroundImage(data, 'hover');
    },
    setBackgroundImage(data, type = 'cover') {

      if (data.type === 'setImage') {
        this.config[type].backgroundColor = 'white';
        this.config[type].backgroundImage = data.src;
      }

      if (data.type === 'removeImage') {
        this.config[type].backgroundImage = 'none';
      }

      if (data.type === 'setConfig') {
        this.config[type].backgroundColor = 'white';
        this.config[type].backgroundPosition = data.position;
        this.config[type].backgroundSize = data.size;
        this.config[type].backgroundRepeat = data.repeat;
        this.config[type].backgroundOrigin = data.origin;
      }

      this.save();
    },
  },
  beforeDestroy() {
    this.config = {};
    this.callback = () => {
    };
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/BoxHover/Options.vue